import { Link } from "react-router-dom";

export default function RFQTable({
    loading,
    data,
    currentPage,
    perPage,
    selectedRows,
    toggleAll,
    toggleRow,
    formatDate
}) {
    const startIdx = (currentPage - 1) * perPage;
    const allSelected = data.every((_, i) => selectedRows[startIdx + i]);

    return (
        <div className="table-responsive border">
            <table className="table align-middle mb-0">
                <thead className="bg-light">
                    <tr>
                        <th className="border">Requirement ID</th>
                        <th className="border">Title</th>
                        <th className="border">Company Name</th>
                        <th className="border">Creation Date</th>
                        <th className="border">Location</th>
                        <th className="border">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={3} className="text-center py-3">
                                Loading...
                            </td>
                        </tr>
                    ) : data.length > 0 ? (
                        data.map((item, index) => {
                            const globalIndex = startIdx + index;
                            return (
                                <tr key={globalIndex}>
                                    <td className="fw-semibold border text-primary">
                                        <Link
                                            to={`/admin-dashboard/detailed-rfq/${item._id}`}
                                            className="text-black underline"
                                        >
                                            {item.requirementId}
                                        </Link>
                                    </td>
                                    <td className="border">
                                        {item.title || "-"}
                                    </td>
                                    <td className="border">
                                        {item.companyName || "-"}
                                    </td>
                                    <td className="border">
                                        {formatDate(item.createdAt) || "-"}
                                    </td>
                                    <td className="border">
                                        {item.supplierLocation || "-"}
                                    </td>
                                    <td className="fw-semibold border text-primary">
                                        <div
                                            className="btn fw-semibold"
                                            style={{
                                                backgroundColor: "#F8F5FF",
                                                color: "#5014D0",
                                                borderRadius: "20px",
                                                padding: "4px 12px",
                                                fontSize: "0.85rem",
                                            }}
                                        >
                                            {item.status || "-"}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={3} className="text-center text-muted py-3">
                                No requirements found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
